/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFilas from './entidades/filas';
import IFiltrosFilas from './entidades/filtrosFilas';

export default class ModeloFilas {
    public consultarFilas() {
        return manejadorRest<IRespuesta<IFilas>>(() => negocioConfiguracion.get('Fila/ConsultarListaFila'), true);
    }
    public crearFilas(filas: IFilas) {
        return manejadorRest<IRespuesta<IFilas>>(() => negocioConfiguracion.post('Fila/GuardarFila', filas), true);
    }
    public editarFilas(filas: IFilas) {
        return manejadorRest<IRespuesta<IFilas>>(() => negocioConfiguracion.put('Fila/EditarFila', filas), true);
    }
    public eliminarFilas(filas: IFilas) {
        return manejadorRest<IRespuesta<IFilas>>(() => negocioConfiguracion.delete('Fila/EliminarFila', filas), true);
    }
    public consultarListaFilasPorFiltro(filtrosFilas: Partial<IFiltrosFilas>) {
        return manejadorRest<IRespuesta<IFilas>>(
            () => negocioConfiguracion.post('Fila/ConsultarListaFilaPorFiltro', filtrosFilas),
            true
        );
    }
}
